var map = {
	"assets/images/relics/CUL/relic_tool-g_t_skysteel-p_t_augmented_dragonsung.png": 3553,
	"assets/images/relics/CUL/relic_tool-g_t_skysteel-p_t_skybuilders.png": 3901,
	"assets/images/relics/CUL/relic_tool-g_t_skysteel-p_t_skysung.png": 5452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2904;